import { StaticPageHeading } from '@tracklib/kit'

type PageHeadingBlockProps = {
  value: {
    heading: string
    label?: string
  }
}

const PageHeadingBlock = ({ value: { heading, label } }: PageHeadingBlockProps): JSX.Element => (
  <StaticPageHeading heading={heading} label={label} />
)

export default PageHeadingBlock
